import anotherLifeModelChange from './actions/anotherLifeModelChange';
import anotherLifeModelCreate from './actions/anotherLifeModelCreate';
import anotherLifeModelDetail from './actions/anotherLifeModelDetail';
import anotherLifeModelList from './actions/anotherLifeModelList';
import anotherLifeModelListUpload from './mutations/anotherLifeModelListUpload';
import getAnotherLifeModelItems from './getters/getAnotherLifeModelItems';

const actions = {
  anotherLifeModelChange,
  anotherLifeModelCreate,
  anotherLifeModelDetail,
  anotherLifeModelList,
};

const mutations = {
  anotherLifeModelListUpload
};

const getters = {
  getAnotherLifeModelItems
}

export default { actions, mutations, getters}